import React from "react";
import "../Styles/ApprovedProfiles.css";
export const Liked = 1;
export const UnLiked = 2;
export const Saved = 3;
export const Shared = 4;
export const Approved = 5;

const ApprovedProfiles = ({ profiles ,moveToMatches}) => {
  console.log("profiles : ", profiles[0]); 

  return (
    <div className="approved-wrapper p-4">
      <h2 className="approved-title">Approved Profiles</h2>
      <div className="profile-card-container">
        {profiles.filter(
                (item) =>
                  [Approved].includes(item.MatchInfo?.Client1Status)
              ).map((profile, index) => (
          <div className="profile-card-box click-effect" key={index} onClick={()=>moveToMatches(profile.ProfileId)} >
            <img
              className="profile-avatar"
               src={
                  profile?.User?.ProfilePhotoUrl
                    ? profile.User.ProfilePhotoUrl
                    : "https://randomuser.me/api/portraits/women/44.jpg"
                }
              alt={profile.name}
            />
            <div className="profile-text-content">
              <h3 className="profile-fullname">
                {" "}
                {profile?.User?.FirstName} {profile?.User?.LastName}{" "}
              </h3>
              <p className="profile-tagline">
                {profile?.BusinessDetails?.BusinessName}
              </p>
              <p className="profile-agent">
                Agent contact number:{" "}
                <span className="profile-agent-number">{  profile?.BusinessDetails?.AgentContactNumber ||
                        profile?.BusinessDetails?.PhoneNumber}   </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApprovedProfiles;
